import React from 'react';

import { Icon } from '@/new/components/icon';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/new/components/shadcn/tooltip';
import { cn } from '@/new/lib/utils';

interface TooltipIconProps {
  side?: 'top' | 'right' | 'bottom' | 'left';
  tooltipContent: React.ReactNode;
  triggerClassName?: string;
  contentClassName?: string;
}

export const TooltipIcon: React.FC<TooltipIconProps> = React.memo(
  ({ side, tooltipContent, triggerClassName, contentClassName }) => (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger>
          <Icon className={cn('lucide--info cursor-pointer text-gray-400', triggerClassName)} />
        </TooltipTrigger>

        <TooltipContent side={side ?? 'top'} className={contentClassName}>
          {tooltipContent}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  ),
);
